__turbopack_context__.v({
  "button": "SaveButton-module__6P5B9a__button",
  "fadeIn": "SaveButton-module__6P5B9a__fadeIn",
  "loading": "SaveButton-module__6P5B9a__loading",
});
